import React, { useState } from "react";
import { Card, Button } from 'react-bootstrap';
import secondTeam from '../assets/2ndTeam.jpg';
// import { validateEmail } from "../utlls/helpers";

function Submit() {
  const [formState, setFormState] = useState({
    firstName: "",
    lastName: "",
    email: "",
    personTitle:"",
    synopsis: "",
    city:"",
    shootLocation: "",
    runTime:"",
    title:"",
    media1:"",
    media2:"",
    media3:"",
    cctexas:"",
    cctotal:"",

  });

  const [errorMessage, setErrorMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
 

  const [formErrors, setFormErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    personTitle:"",
    synopsis: "",
    city:"",
    shootLocation: "",
    runTime:"",
    title:"",
    cctexas:"",
    cctotal:"",
  });

  function handleChange(e) {
    setFormState({ ...formState, [e.target.name]: e.target.value });
    setFormErrors({ ...formErrors, [e.target.name]: e.target.value ? "" : "This field is required" });
  }
  

  async function handleSubmit(e) {
    e.preventDefault();

    const hasErrors = Object.values(formErrors).some((error) => error !== "");

    if (hasErrors) {
      setErrorMessage("*Please fill out all fields*");
      
      return;
    }

    console.log('Form state before fetch:', formState);
    try {
      const response = await fetch("http://localhost:3001/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: 'application/json, text/plain, */*',
        },
        body: JSON.stringify(formState),
      });
      
      if (response.ok) {
        console.log("Form submitted successfully");
        // Reset the form
        setFormState({
          firstName: "",
          lastName: "",
          email: "",
          personTitle: "",
          synopsis: "",
          city: "",
          shootLocation: "",
          runTime:"",
          title:"",
          media1:"",
          media2:"",
          media3:"",
          cctexas:"",
          cctotal:"",
        });

        // Set the submitted state to true
        setSubmitted(true);

      } else {
        console.error("Form submission failed");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div  
    style={{ 
      justifyContent: 'center', 
      alignItems: 'center',
      marginRight: '10%',
      marginLeft: '10%',
      marginBottom: '20%'
      }}>
    {submitted ? (
  <div style={{ 
    marginBottom: '40%',
    marginTop: '40%' }}>
    <h1 className=" justify-content-center"
    style={{ marginBottom: '3%', }}>
      Thank you for your submission, we'll get back to you soon!
    </h1>
    <div>
      <div className='d-flex justify-content-center'
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: 'black',
          boxShadow: '0px 0px 10px white',
        }}
      >
        <img src={secondTeam} alt='secondteamlogo' className="img-fluid" />
      </div>
    </div>
  </div>
) : (

    <>
       <div> 
       <h1 className="justify-content-center section-title"
       style={{
        marginTop: '5%'}}
       > 
        
        Submit Your Film</h1>
          <Card  className=" p-4 card-body"
                    style={{
                      margin: '1%',
                      width: 'auto',
                      height: 'auto',
                      boxSizing: 'border-box',
                      }}>
              
              <br></br>
              <div >
              <h2 className="justify-content-center"
              style={{
                marginBottom:'0%',
                }}>Our Process</h2>
              <div>
              <Card.Text style={{
                padding: '1%',
                marginTop:'1%',}}>
                If you would like to have your film hosted on 2nd Team Productions, please
                fill out the form below and we'll contact you to schedule a time
                to discuss your film as well as your goals. 
              </Card.Text>
              <Card.Text style={{
                padding: '1%'}}>
                If it's a suitable fit, we'll ask you to provide your film and sizzle reel, 
                as well as information about the film's cast and crew (contact information, bios, links to 
                professional sites etc.).
              </Card.Text>
              <Card.Text style={{
                padding: '1%'}}>
                From there, we'll generate your film's webpage which will include your reel,
                movie, and information about your cast and crew.
              </Card.Text>
              </div>
              </div>
            </Card>
            </div>
      <br />
      <div 
      style={{
        marginBottom:'2.5%',
        }}>
      <Card className="card-body flex-column align-items-center"
     style={{ minHeight: '100%', }}
      >
        <form onSubmit={handleSubmit}
        className=" justify-content-center"
        style={{
          marginTop:'2.5%'
          }}
         >
           <h2 className="justify-content-center"
          >Filmmaker Information</h2>
            <div>
            <div className="row w-100 justify-content-center" style={{ marginBottom: '3%' }}>
            <div className="col-md-5 d-flex flex-column align-items-center mb-2">
              <label>
                <h3>
                 First name</h3>
              </label>
              <input
               style={{
                background: 'none',
                border: 'none',
                justifyContent: 'center',
                textAlign: 'center',
                color: 'silver',
                caretColor: 'grey',
                width: '90%',
              }}
                type="text"
                value={formState.firstName}
                onChange={handleChange}
                name="firstName"
                className="process-card-text"
              />
            </div>
            <div className="col-md-5 d-flex flex-column align-items-center mb-2">
              <label>
                <h3>
                  Last name</h3>
              </label>
              <input
               style={{
                background: 'none',
                border: 'none',
                justifyContent: 'center',
                textAlign: 'center',
                color: 'silver',
                caretColor: 'grey',
                width: '90%',
              }}
                type="text"
                value={formState.lastName}
                onChange={handleChange}
                name="lastName"
                className="process-card-text"
              />
            </div>
        
          </div>
          <div className="row w-100 justify-content-center" style={{ marginBottom: '3%' }}>
            <div className="col-md-5 d-flex flex-column align-items-center mb-2">
              <label>
              <h3>
                  Email</h3>
              </label>
              <input
               style={{
                background: 'none',
                border: 'none',
                justifyContent: 'center',
                textAlign: 'center',
                color: 'silver',
                caretColor: 'grey',
                width: '90%',
              }}
                type="email"
                value={formState.email}
                onChange={handleChange}
                name="email"
                className="process-card-text"
              />
            </div>

            <div className="col-md-5 d-flex flex-column align-items-center mb-2"
            >
              <label>
              <h3>
                  City</h3>
              </label>
              <input
               style={{
                background: 'none',
                border: 'none',
                justifyContent: 'center',
                textAlign: 'center',
                color: 'silver',
                caretColor: 'grey',
                width: '90%',
              }}
                type="text"
                value={formState.city}
                onChange={handleChange}
                name="city"
                className="process-card-text"
              />
            </div>
          </div>
          
          <div>
          </div>
            </div>
            <h2 className="justify-content-center">
            Film information</h2>
          <div  style={{
              marginBottom:'3%'}}>
            <div className="row w-100 justify-content-center" style={{ marginBottom: '3%' }}>
            <div className="col-md-5 d-flex flex-column align-items-center mb-3">
              <label>
              <h3>
                  Title</h3>
              </label>
              <input
               style={{
                background: 'none',
                border: 'none',
                justifyContent: 'center',
                textAlign: 'center',
                color: 'silver',
                caretColor: 'grey',
                width: '90%',
                marginBottom: '3%' 
              }}
                type="text"
                value={formState.title}
                onChange={handleChange}
                name="title"
                className="process-card-text"
              />
            </div>
              <label htmlFor="message">
                  <h3 className="justify-content-center">
                synopsis
              </h3>
              </label>
              <textarea
                className="col-md-5 d-flex flex-column align-items-center mb-2 process-card-text"
                value={formState.synopsis}
                onChange={handleChange}
                name="synopsis"
                rows="6"
                style={{
                  background: 'none',
                  border: 'none',
                  justifyContent: 'center',
                  marginBottom: '5%',
                  color: 'silver',
                  caretColor: 'grey',
                  width: '90%',
                  marginBottom: '3%' 
                }}
              />
            </div>
          <div className="row w-100 justify-content-center" style={{ marginBottom: '3%' }}>
            <div className="col-md-5 d-flex flex-column align-items-center mb-3"
            >
              <label>
              <h3>
                  Run time</h3>
              </label>
              <input
               style={{
                background: 'none',
                border: 'none',
                justifyContent: 'center',
                textAlign: 'center',
                color: 'silver',
                caretColor: 'grey',
                width: '90%',
                marginBottom: '3%' 
              }}
                type="text"
                value={formState.runTime}
                onChange={handleChange}
                name="runTime"
                className="process-card-text"
              />
            </div>
            <div className="col-md-5 d-flex flex-column align-items-center mb-3"
            >
              <label>
              <h3>
                  Shoot Location</h3>
              </label>
              <input
               style={{
                background: 'none',
                border: 'none',
                justifyContent: 'center',
                textAlign: 'center',
                color: 'silver',
                caretColor: 'grey',
                width: '90%',
                marginBottom: '3%' 
              }}
                type="text"
                value={formState.shootLocation}
                onChange={handleChange}
                name="shootLocation"
                className="process-card-text"
              />
            </div>
   
            <div className="row w-100 justify-content-center" style={{ marginBottom: '3%' }}>
            <div className="col-md-5 d-flex flex-column align-items-center mb-3"
            >
              <label>
              <h3>
                  Total # cast and crew</h3>
              </label>
              <input
               style={{
                background: 'none',
                border: 'none',
                justifyContent: 'center',
                textAlign: 'center',
                color: 'silver',
                caretColor: 'grey',
                width: '90%',
              }}
                type="text"
                value={formState.cctotal}
                onChange={handleChange}
                name="cctotal"
                className="process-card-text"
              />
            </div>
            <div className="col-md-5 d-flex flex-column align-items-center mb-2"
            >
              <label>
              <h3>
                  total # that are texas residents</h3>
              </label>
              <input
               style={{
                background: 'none',
                border: 'none',
                justifyContent: 'center',
                textAlign: 'center',
                color: 'silver',
                caretColor: 'grey',
                width: '90%',
              }}
                type="text"
                value={formState.cctexas}
                onChange={handleChange}
                name="cctexas"
                className="process-card-text"
              />
            </div>
            </div>
            <div className="col d-flex flex-column align-items-center"
            >
              <label>
              <h3>Media Links</h3>
              </label>
              <div className="row w-100 justify-content-center" >
              <div className="col d-flex flex-column align-items-center mb-2"
              style={{ margin: '1%'}}
              >
              <input className="process-card-text"
                type="text"
                value={formState.media1}
                onChange={handleChange}
                name="media1" 
                style={{
                  background: 'none',
                  border: 'none',
                  justifyContent: 'center',
                  textAlign: 'center',
                  color: 'silver',
                  caretColor: 'grey',
                  width: '100%',
                }}
              />
              </div>

              <div className="col d-flex flex-column align-items-center mb-2"
              style={{ margin: '1%'}}
              >
              <input className="process-card-text"
                type="text"
                value={formState.media2}
                onChange={handleChange}
                name="media2"
                style={{
                  background: 'none',
                  border: 'none',
                  justifyContent: 'center',
                  textAlign: 'center',
                  color: 'silver',
                  caretColor: 'grey',
                  width: '100%',
                }}
              />
              </div>

              <div className="col d-flex flex-column align-items-center mb-2"
              style={{ margin: '1%'}}
              >
              <input className="process-card-text"
                type="text"
                value={formState.media3}
                onChange={handleChange}
                name="media3"
                style={{
                  background: 'none',
                  border: 'none',
                  justifyContent: 'center',
                  textAlign: 'center',
                  color: 'silver',
                  caretColor: 'grey',
                  width: '100%',
                }}
              />
              </div>
              </div>
            </div>
            </div>
          </div>
          <br />
          {errorMessage && (
            <div>
              <h2 className="error-text justify-content-center"
              style={{
                marginTop: "2%",
              }}
              
              >{errorMessage}</h2>
            </div>
          )}
          <div>
            <div>
              <Button 
              className="process-card-text hover-brighten" 
              type="submit"
              style={{
                position: 'relative',
                marginRight: '50%',
                marginLeft: '50%',
                marginTop: '3%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'rgb(67, 66, 66)',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
              > 
              <h3 className=" text-center"
               style={{
                margin: "1%",
              }}
              >
                  Submit</h3>
                </Button>
            </div>
          </div>
        </form>
        </Card>
      </div>
      
    </>
    )}
    </div>
  );
}

export default Submit;
